export default (props, traits) => {
  const { colors, rhythm, scale, treatments } = traits

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },

    detail: {
      ...treatments.head,
      fontSize: scale(2)
    },

    meta: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 0.5,
      fontSize: scale(-0.5),
      margin: rhythm([0.5, 0, 0.75]),

      '& > div + div': {
        marginLeft: rhythm(0.5),

        '&:before': {
          content: '"|"',
          marginRight: rhythm(0.5)
        }
      }
    },

    message: {
      backgroundColor: colors.shade,
      maxWidth: rhythm(15),
      padding: rhythm([0.5, 1]),
      borderRadius: rhythm([0, 1, 1, 1]),
      marginBottom: rhythm(0.5)
    },

    status: {
      display: 'inline-flex',
      maxWidth: rhythm(15),
      alignItems: 'center',
      padding: rhythm([0.5, 1]),
      marginBottom: rhythm(0.5),
      backgroundColor: colors.shade,
      borderRadius: rhythm(1),
      fontSize: scale(-1),

      '& svg': {
        display: 'block',
        marginRight: rhythm(0.25)
      }
    },

    label: {
      opacity: 0.5,
      marginBottom: rhythm(0.25)
    },

    page: {
      textAlign: 'left',
      width: '100%',
      maxWidth: rhythm(20),
      margin: `0 auto ${rhythm(0.5)}`
    }
  }
}
